import { httpClient } from '../httpClient';
import { ImageGenerationParams, AudioGenerationParams, VideoGenerationRequest, IVideoClipResource, CreateAudioEditingRequest } from '@packages/global';

export class VideoClipResourceApi {
  /**
   * 生成开始帧图片
   */
  async generateStartImage(videoClipId: string, params: ImageGenerationParams): Promise<any> {
    return httpClient.post(`/user/videoclips/${videoClipId}/generate/start-image`, params);
  }

  /**
   * 生成结束帧图片
   */
  async generateEndImage(videoClipId: string, params: ImageGenerationParams): Promise<any> {
    return httpClient.post(`/user/videoclips/${videoClipId}/generate/end-image`, params);
  }

  /**
   * 生成分镜图片
   */
  async generateStoryboardImage(videoClipId: string, params: ImageGenerationParams): Promise<any> {
    return httpClient.post(`/user/videoclips/${videoClipId}/generate/storyboard-image`, params);
  }

  /**
   * 生成配音
   */
  async generateScriptAudio(videoClipId: string, params: AudioGenerationParams): Promise<any> {
    return httpClient.post(`/user/videoclips/${videoClipId}/generate/audio`, params);
  }

  /**
   * 生成视频
   */
  async generateVideo(videoClipId: string, params: VideoGenerationRequest): Promise<any> {
    return httpClient.post(`/user/videoclips/${videoClipId}/generate/video`, params);
  }

  /**
   * 生成对口型视频
   */
  async generateLipSync(videoClipId: string, params: { videoUrl: string; audioUrl: string; modelId: string }): Promise<any> {
    return httpClient.post(`/user/videoclips/${videoClipId}/generate/lip-sync`, params);
  }

  /**
   * 生成音频编辑（变声）
   */
  async generateAudioEdit(videoClipId: string, params: CreateAudioEditingRequest): Promise<any> {
    return httpClient.post(`/user/videoclips/${videoClipId}/generate/audio-edit`, params);
  }

  /**
   * 查询资源生成状态
   */
  async getResourcesStatus(videoClipId: string): Promise<IVideoClipResource[]> {
    return httpClient.get(`/user/videoclips/${videoClipId}/resources`);
  }

  /**
   * 批量查询多个视频片段的资源状态
   */
  async getBatchResourcesStatus(clipIds: string[]): Promise<Record<string, IVideoClipResource[]>> {
    if (clipIds.length === 0) return {};
    return httpClient.get(`/user/videoclips/batch/resources-status?clipIds=${clipIds.join(',')}`);
  }

  /**
   * 删除资源记录
   */
  async deleteResource(resourceId: string): Promise<any> {
    return httpClient.delete(`/user/videoclips/resources/${resourceId}`);
  }
}

export const videoClipResourceApi = new VideoClipResourceApi();
